import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var definitionListDescription = createRuntimeFn({defaultClassName:'fx_e395032e_1uk2fnd0',variantClassNames:{monospace:{true:'fx_e395032e_1uk2fnd1',false:'fx_e395032e_1uk2fnd2'}},defaultVariants:{monospace:false},compoundVariants:[]});

export { definitionListDescription };
//# sourceMappingURL=definitionListDescription.vanilla.mjs.map
